import moment from 'moment';
import _ from 'lodash';
import { CALENDAR_CONSTANT } from '../UI_V2_Components/shared/calendar/constants';

const firstWeekday = (year, month) => {
  const theDate = moment(`${('0000' + year).slice(-4)}-${('00' + month).slice(-2)}-01`);
  return moment(theDate).isoWeekday();
};

const daysInMonth = (year, month) => {
  const theDate = moment(`${('0000' + year).slice(-4)}-${('00' + month).slice(-2)}-01`);
  return moment(theDate).daysInMonth();
};

const isWeekend = (year, month, day) => {
  const theDate = moment(`${('0000' + year).slice(-4)}-${('00' + month).slice(-2)}-${('00' + day).slice(-2)}`);
  const weekday = moment(theDate).isoWeekday();
  return weekday === 6 || weekday === 7;
};

const sameTimeSlotsOrEmpty = (listA, listB, timeZone) => {
  if (!listA.length || !listB.length) return true;
  if (listA.length !== listB.length) return false;

  /* OUR LIST ARE SORTED, SO THIS SHOULD BE QUICK */
  const someNotEqual = listA.some((item, index) => {
    const timeSlot = moment(item.slot).tz(timeZone).format('HH:mm');
    const otherTimeSlot = moment(listB[index].slot).tz(timeZone).format('HH:mm');
    if (timeSlot !== otherTimeSlot) {
      return true;
    }
  });

  return !someNotEqual;
};

const splitListDateTimes = (list, month, timeZone) => {
  const dates = [];
  let slots = [];
  if (!list || !list.length) return { dates, slots };

  let index = 0;
  let multiDatesWithDifferentTimeSlots = false;
  let lastTimeSlotList = [];

  while (index < list.length) {
    const firstDate = moment(list[index].slot).tz(timeZone);
    const m = firstDate.month() + 1; /* JAN = 0 */
    const d = firstDate.date();

    if (m !== month) {
      /* EDGE CASE - WHEN SWITCHING TIME ZONE, THERE COULD BE DATES THAT FALL TO ANOTHER MONTH */
      index++;
      continue;
    }

    const sameDateSlots = list.filter((date) => firstDate.isSame(moment(date.slot).tz(timeZone), CALENDAR_CONSTANT.COMPARE_DAY) &&
      date.tag === CALENDAR_CONSTANT.TAG_TIME_SLOT);

    /* PUSH THE DATE NUMBER TO LIST */
    dates.push({ dateNumber: d, hasSlots: sameDateSlots.length > 0, tag: list[index].tag });

    /* IF THE DATE IS NOT SELECTED, DON'T CHECK FOR DIFFERENT TIME SLOTS */

    if (list[index].tag !== CALENDAR_CONSTANT.TAG_DATE_SELECTED) {
      /* NEXT BATCH */
      sameDateSlots.length ? index += (sameDateSlots.length + 1) : index++;
      continue;
    }

    /* PUSH THE TIME */
    if (!multiDatesWithDifferentTimeSlots) {
      /* CHECK IF THE TIME SLOTS ARE DIFFERENT */
      let isSame = sameTimeSlotsOrEmpty(sameDateSlots, lastTimeSlotList, timeZone);
      if (isSame) isSame = sameTimeSlotsOrEmpty(lastTimeSlotList, sameDateSlots, timeZone);

      if (!isSame) {
        multiDatesWithDifferentTimeSlots = true;
        lastTimeSlotList = [];
        slots = [];
      } else {
        sameDateSlots.forEach((date, index) => {
          slots.push({ slot: moment(date.slot).tz(timeZone).format() });
        });

        lastTimeSlotList = sameDateSlots;
        slots = _.uniqBy(slots, 'slot');
      }
    }

    /* NEXT BATCH */
    sameDateSlots.length ? (index += sameDateSlots.length + 1) : index++;
  }

  return { dates, slots, multiDatesWithDifferentTimeSlots };
};

export {
  firstWeekday,
  daysInMonth,
  isWeekend,
  splitListDateTimes
};
